export const getEtfFiltersByClass = /* GraphQL */ `
  query GetEtfFiltersByClass(
    $filterClass: ID!
  ){
    getFilterDefinition(id: $filterClass) {
      id
      filter {
        items {
          filterItem
          id
          name
          orderNumber
          filterValues {
            id
            values {
              id
              name
              orderNumber
            }
          }
          defaultValues
        }
        nextToken
      }
    }
  }
`
